import React, { useState, useEffect, useContext, useCallback } from 'react';
import Postnav from '../../components/Postnav/Postnav';
import PublicaConNosotros from '../../components/PublicaConNosotros/PublicaConNosotros';
import MisDatos from '../../components/MisDatos/MisDatos';
import InfoCuentas from '../../Hooks/InfoCuentas';
import './d-cuenta.css';
import Loader from '../../components/Loader/Loader';
import { InfoCuentasContext } from '../../Hooks/InfoCuentasContext';
import CrearTienda from '../../components/PublicaConNosotros/CrearTienda';
import Publicacion from '../../components/PublicaConNosotros/Publicacion';
import Tiendas from '../../components/Tiendas/Tiendas';
import MisPublicaciones from '../../components/MisPublicaciones/MisPublicaciones';
import MisCompras from '../../components/MisCompras/MisCompras';
import MisVentas from '../../components/MisVentas/MisVentas';

// `pendiente` marks a section with no component yet. Those used to render an
// empty pane, which reads as a broken page rather than an unbuilt one.
const SECCIONES = [
  { id: 'MisDatos', label: 'Mis Datos' },
  { id: 'MisCompras', label: 'Mis Compras' },
  { id: 'Tiendas', label: 'Tiendas' },
  { id: 'MisPublicaciones', label: 'Mis Publicaciones' },
  { id: 'MisVentas', label: 'Mis Ventas' },
  { id: 'Seguridad', label: 'Seguridad' },
];

const SECCIONES_APARTE = [
  { id: 'AdministrarFavoritos', label: 'Administrar Favoritos', pendiente: true },
  { id: 'AlertasBusqueda', label: 'Alertas de Búsqueda', pendiente: true },
];

const PENDIENTES = [...SECCIONES, ...SECCIONES_APARTE]
  .filter((s) => s.pendiente)
  .map((s) => s.id);

function Cuenta() {
  const { isAuthenticated, tiendas } = useContext(InfoCuentasContext);
  const [componenteActual, setComponenteActual] = useState('PublicaConNosotros');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      window.location.href = '/login';
    } else {
      setIsLoading(false);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      setComponenteActual(hash || 'PublicaConNosotros');
    };

    window.addEventListener('hashchange', handleHashChange);
    handleHashChange();

    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const cerrarSesion = useCallback(() => {
    fetch('/api/logout', { method: 'POST', credentials: 'include' })
      .then((response) => {
        if (!response.ok) throw new Error('Logout failed');
        localStorage.removeItem('nombre');
        localStorage.removeItem('direccion');
        window.location.href = '/';
      })
      .catch((error) => console.error('Error during logout:', error));
  }, []);

  const handleClick = (seccion) => {
    if (seccion === 'Tiendas' && tiendas.length === 0) {
      window.location.hash = 'crear-tienda';
      return;
    }
    window.location.hash = seccion;
  };

  if (isLoading) return <Loader />;

  const botones = (lista) => lista.map((s) => (
    <button
      key={s.id}
      type="button"
      className={`boton-cuenta ${componenteActual === s.id ? 'activo' : ''}`}
      onClick={() => handleClick(s.id)}
    >
      {s.label}
    </button>
  ));

  const seccionPendiente = PENDIENTES.includes(componenteActual);

  return (
    <div className="outheader">
      <div className="background">
        <div className="background-center-color">
          <div className="postnav-container">
            <Postnav />
          </div>

          <div className="cuenta-page">
            <div className="maincolumns">
              <nav className="cuenta-left-column" aria-label="Mi cuenta">
                <div className="cuentas-left-column-totem">
                  <div className="ontop-cuentas-left-column-totem">
                    <button
                      type="button"
                      className="boton-cuenta boton-cuenta-destacado"
                      onClick={() => handleClick('PublicaConNosotros')}
                    >
                      Publicá con nosotros
                    </button>
                  </div>

                  <div className="center-cuentas-left-column-totem">
                    {botones(SECCIONES)}
                  </div>

                  <div className="apart-cuentas-left-column-totem">
                    {botones(SECCIONES_APARTE)}
                  </div>

                  <div className="bottom-cuentas-left-column-totem">
                    <button
                      type="button"
                      className="boton-cuenta boton-cuenta-salir"
                      onClick={cerrarSesion}
                    >
                      Cerrar sesión
                    </button>
                  </div>
                </div>
              </nav>

              <section className="cuenta-center-column">
                {componenteActual === 'PublicaConNosotros' && <PublicaConNosotros />}
                {componenteActual === 'MisDatos' && <MisDatos />}
                {componenteActual === 'Seguridad' && <InfoCuentas />}
                {componenteActual === 'crear-tienda' && <CrearTienda />}
                {componenteActual === 'crear-aviso' && <Publicacion />}
                {componenteActual === 'Tiendas' && <Tiendas />}
                {componenteActual === 'MisPublicaciones' && <MisPublicaciones />}
                {componenteActual === 'MisCompras' && <MisCompras />}
                {componenteActual === 'MisVentas' && <MisVentas />}

                {seccionPendiente && (
                  <div className="cuenta-placeholder">
                    <h3>Esta sección todavía no está disponible.</h3>
                    <p>Estamos trabajando en ella.</p>
                  </div>
                )}
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cuenta;
